import { SubscriptionPlan } from 'models/SubscriptionPlan';

export interface Address {
    id: number;
    name: string;
    firstName: string;
    isCompany: boolean;
    street: string;
    city: string;
    state: string;
    country: string;
    zipCode: string;
}

// values match the backend enum PaymentType
export enum PaymentType {
    Invoice = 1,
    Credit = 2,
    Debit = 3,
    Paypal = 4
}

export interface Payment {
    paymentType: PaymentType;
    invoiceDay: number;
    billingAddress: Address | null;
}

export class Tenant {
    id: number;
    name: string;
    subscriptionPlan: SubscriptionPlan | null;
    address?: Address | null;
    payment?: Payment | null;
    archivedDate?: Date;

    constructor(
        id: number,
        name: string,
        subscriptionPlan: SubscriptionPlan | null,
        archivedDate?: Date
    ) {
        this.id = id;
        this.name = name;
        this.subscriptionPlan = subscriptionPlan;
        this.archivedDate = archivedDate;
    }
}
